// *** TRANSLATION SERVICE ***

// LOCALES
export const locales = ['en', 'fi', 'sv'];

// LOCALE DATETIME FORMATS
const localeDatetimeFormats = {
    en: 'YYYY-MM-DD hh:mm:ss',
    fi: 'DD.MM.YYYY hh:mm:ss',
    sv: 'DD.MM.YYYY hh:mm:ss'
};

// *** GET LOCALE'S DATETIME FORMAT ***
export const getLocaleDatetimeFormat = locale => {
    if (localeDatetimeFormats[locale]) {
        return localeDatetimeFormats[locale];
    }
    return 'DD.MM.YYYY hh:mm:ss';
};

// *** FORMAT CURRENCY BASED ON LOCALE ***
export const formatCurrency = (number, locale) => {
    if (typeof number == 'undefined') {
        return 'Missing base price';
    }
    return number.toLocaleString(locale, {
        style: 'currency',
        currency: 'EUR'
    });
};

// DATETIME FORMATS
export const dateTimeFormats = {
    en: {
        short: {
            year: 'numeric',
            month: 'numeric',
            day: '2-digit'
        },
        long: {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            weekday: 'short',
            hour: 'numeric',
            minute: 'numeric'
        },
        dateTimeSec: {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric'
        }
    },
    fi: {
        short: {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        },
        long: {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            weekday: 'short',
            hour: 'numeric',
            minute: 'numeric'
        },
        time: {
            hour: 'numeric',
            minute: 'numeric'
        },
        dateTimeSec: {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric'
        }
    },
    sv: {
        short: {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        },
        long: {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            weekday: 'short',
            hour: 'numeric',
            minute: 'numeric'
        },
        time: {
            hour: 'numeric',
            minute: 'numeric'
        },
        dateTimeSec: {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric'
        }
    }
};
